<template>
  <button type="button" class="tile" @click="router.push(setting.to)">
    <div class="tile-icon" :class="{ 'tile-icon--image': setting.imageSrc }">
      <img v-if="setting.imageSrc" :src="setting.imageSrc" :alt="setting.label" class="tile-logo" />
      <font-awesome-icon v-else-if="setting.icon" :icon="setting.icon" />
    </div>
    <span class="tile-title">{{ setting.label }}</span>
    <code v-if="setting.identifier" class="tile-identifier">{{ setting.identifier }}</code>
  </button>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useRouter } from 'vue-router'

const router = useRouter()
const props = defineProps<{
  setting: {
    label: string
    to: string
    icon?: string
    imageSrc?: string
    identifier?: string
  }
}>()
</script>

<style scoped>
.tile-icon--image {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #ece9e1;
}

.tile-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.35rem;
}

.tile-identifier {
  margin-top: 0.2rem;
  font-size: 0.78rem;
  color: #6b6e75;
  background: #f7f7f5;
  border: 1px solid #ece9e1;
  border-radius: 6px;
  padding: 0.12rem 0.45rem;
}
</style>
